import React, { useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FiHome, FiShoppingBag, FiShoppingCart, FiUser } from 'react-icons/fi';
import { useCart } from '../context/CartContext';
import './BottomNav.css';

const BottomNav = () => {
  const { cartCount } = useCart();
  const navigate = useNavigate();
  const lastTap = useRef({});

  const handleNavTap = (e, path) => {
    e.preventDefault();
    const now = Date.now();
    const DOUBLE_TAP_DELAY = 300; // ms

    if (
      lastTap.current.path === path &&
      now - lastTap.current.time < DOUBLE_TAP_DELAY
    ) {
      // Double tap — scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Single tap — normal navigation
      navigate(path);
    }

    lastTap.current = { path, time: now };
  };

  return (
    <nav className="bottom-nav">
      <NavLink to="/" end className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`} onClick={(e) => handleNavTap(e, '/')}>
        <FiHome size={22} />
        <span>Home</span>
      </NavLink>

      <NavLink to="/shop" className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`} onClick={(e) => handleNavTap(e, '/shop')}>
        <FiShoppingBag size={22} />
        <span>Shop</span>
      </NavLink>

      <NavLink to="/cart" className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`} onClick={(e) => handleNavTap(e, '/cart')}>
        <div className="bottom-nav-cart-wrap">
          <FiShoppingCart size={22} />
          {cartCount > 0 && (
            <span className="bottom-nav-badge">{cartCount > 9 ? '9+' : cartCount}</span>
          )}
        </div>
        <span>Cart</span>
      </NavLink>

      <NavLink to="/account" className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`} onClick={(e) => handleNavTap(e, '/account')}>
        <FiUser size={22} />
        <span>Account</span>
      </NavLink>
    </nav>
  );
};

export default BottomNav;
